import { render } from "./AuthCallbackPage.vue?vue&type=template&id=1d7581d8&scoped=true"
import script from "./AuthCallbackPage.vue?vue&type=script&lang=js"
export * from "./AuthCallbackPage.vue?vue&type=script&lang=js"

import "./AuthCallbackPage.vue?vue&type=style&index=0&id=1d7581d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7581d8"]])

export default __exports__